import { ignoredFormKeyCodes } from "../../ignored_form_key_codes";

const NUM_KEYS = new Array(10).fill(null).map((_, i) => i.toString());
const ALLOWED_KEYS_NUMERIC = [...NUM_KEYS, ...ignoredFormKeyCodes];

const CVV_MIN_LENGTH = 3;
const CVV_MAX_LENGTH = 4;

export function numericOnlyFilter (char) {
  return /^\d$/.test(char);
}

export function filterNonNumericCharacters (value) {
  return value.split("").filter(numericOnlyFilter).join("");
}

export function CVVFilter (value) {
  return filterNonNumericCharacters(value.slice(0, CVV_MAX_LENGTH));
}

export function ccEDKeydownHandler (event) {
  if (event.key == 'Enter') {
    event.stopPropagation();
    event.preventDefault();
    return;
  }
  if (![event.metaKey, event.altKey, event.ctrlKey].some(active => active)) {
    if (!ALLOWED_KEYS_NUMERIC.includes(event.key) && !ignoredFormKeyCodes.includes(event.keyCode)) {
      event.preventDefault();
      return;
    }
    if (ignoredFormKeyCodes.includes(event.keyCode)) {
      return;
    }
  }

  event.target.value = CVVFilter(event.target.value);
}

export function ccEDKeyupHandler (event) {
  if (event.key == 'Enter') {
    event.stopPropagation();
    event.preventDefault();
    return;
  }
  if (ignoredFormKeyCodes.includes(event.keyCode)) {
    return;
  }

  event.target.value = CVVFilter(event.target.value);
}

export function ccEDPasteHandler (event) {
  const pasteData = event.clipboardData.getData("text");
  event.preventDefault(pasteData);
  event.target.value = CVVFilter(pasteData);
}

export function setupCCCVVInput (inputElement) {
  inputElement.addEventListener("keydown", ccEDKeydownHandler);
  inputElement.addEventListener("keyup", ccEDKeyupHandler);
  inputElement.addEventListener("paste", ccEDPasteHandler);

  inputElement.setAttribute("maxlength", CVV_MAX_LENGTH);
  inputElement.setAttribute("pattern", `^[0-9]{${CVV_MIN_LENGTH},${CVV_MAX_LENGTH}}$`)

  return new Proxy(inputElement, {
    get (target, prop, _receiver) {
      switch (prop) {
        case "value":
          return CVVFilter(target.value);
        case "_self":
          return target;
        default:
          return Reflect.get(...arguments);
      }
    },
    set (target, prop, value, _receiver) {
      if (prop === "value") {
        target.value = CVVFilter(value.toString());
      } else {
        return Reflect.set(...arguments);
      }
      return true;
    }
  });
}
